import { render, staticRenderFns } from "./V2ProductEditContent.vue?vue&type=template&id=052a8598&scoped=true&"
import script from "./V2ProductEditContent.vue?vue&type=script&lang=js&"
export * from "./V2ProductEditContent.vue?vue&type=script&lang=js&"
import style0 from "./V2ProductEditContent.vue?vue&type=style&index=0&id=052a8598&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052a8598",
  null
  
)

export default component.exports